













import {defineComponent, reactive, ref, watch} from "@vue/composition-api"
import {getAutocompleteFn} from "@/data/sources/autocomplete"
import {deepCopy} from "@/utils"

function fetchItemEntries(state: any) {
  state.h.forEach((item: any, idx: number) => {
    updateItemEntries(item)
  })
}

function setupParentElementWatchers(state: any) {
  state.h.forEach((item: any, idx: number) => {
    // setup parent item change watcher for all levels except 0 which has no parent
    if (idx > 0) {
      const parent = state.h[idx - 1]
      watch(() => parent, (parent) => {
        updateItemEntries(item, parent.selected)
        // if parent has changed, reset current item selected item but skip during component initialization
        if (state.initialized) {
          item.selected = undefined
        }
      }, {deep: true})
    }
  })
}

function updateItemEntries(item: any, parent: string = "") {
  setTimeout(async () => {
    const af = getAutocompleteFn(item.autocompleteFn)
    item.entries = [{value: undefined, title: null}, ...await af("", String(parent || ""))]
    if (!item.selected) {
      for (const e of item.entries) {
        if (e.isDefault) {
          item.selected = e.value
        }
      }
    }
  }, 0)
}

export default defineComponent({
  props: {
    opts: Object,
    value: Object,
  },
  components: {},
  setup(props, ctx) {
    const opts = props.opts || {}
    const val = props.value && deepCopy({}, props.value)
    const h = ref(Object.keys(opts.layout).map((k: any) => {
      if (!val[opts.layout[k].name]) {
        val[opts.layout[k].name] = {value: undefined, title: null}
      }
      return {...opts.layout[k], selected: undefined, entries: []}
    }) || [])

    const state = reactive({
      inputId: "cascadedInput-" + String(Math.floor((Math.random() * 100000))),
      val: val,
      extendedValue: "",
      focused: false,
      showAutocomplete: false,
      initialized: false,
      h,
    })
    setTimeout(() => state.initialized = true, 2000)
    state.h.forEach((item: any, idx: number) => {
      if (val && val[item.name]) {
        state.h[idx].selected = val[item.name].value
      }
      watch(() => item.selected, (v: any, old: any) => {
        const newVal = {title: item.title, value: v}
        item.entries.forEach((e: any) => {
          if (e.value === v) {
            newVal.title = e.title
          }
        })
        state.val[item.name] = newVal
        ctx.emit('input', state.val)
      }, {lazy: true})
    })
    fetchItemEntries(state)
    setupParentElementWatchers(state)
    const save = (v: any) => {
      // state.extendedValue = `(${v.value}) ${v.title}`
      // ctx.emit('input', {hLevel: v.name, title: v.title, value: v.value})
    }
    return {props, ctx, state, save}
  },
})

